import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { url } from '../../api/axios_client';
import { useNavigate } from 'react-router-dom';
import './HomeContentEditor.css';
import axios from '../../api/axios_client';
import { Input } from "@mui/material";

const HomeContentEditor = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [activeLanguage, setActiveLanguage] = useState('en');
    // const [isDirty, setIsDirty] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [logoPreview, setLogoPreview] = useState();
    const [showArabicFields, setShowArabicFields] = useState(false);
    const [content, setContent] = useState({
        org: '',
        org_ar: '',
        title: '',
        title_ar: '',
        logo: null,
        file: '',
        definition: {
            pt1: '',
            pt2: '',
            pt1_ar: '',
            pt2_ar: ''
        },
        about: '',
        about_ar: '',
        explore: '',
        explore_ar: '',
        terms: '',
        terms_ar: '',
        privacy: '',
        privacy_ar: '',
        contact: {
            email: '',
            phone: '',
            email_ar: '',
            phone_ar: ''
        },
        copyright: '',
        copyright_ar: ''
    });

    useEffect(() => {
        fetchContent();
    }, [activeLanguage]);

    const fetchContent = async () => {
        try {
            const response = await axios.get(`${url}/api/admin/home-content/${activeLanguage}`);
            if (response.status === 200) {
                const data = await response.data;
                setContent(data);
                // setIsDirty(false);
            } else {
                toast.error('Failed to fetch content');
                console.log(response.data)
                // Fallback to translation if fetch fails
                loadContent(activeLanguage);
            }
        } catch (error) {
            console.error('Error fetching content:', error);
            toast.error('Error fetching content');
            // Fallback to translation if fetch fails
            loadContent(activeLanguage);
        }
    };

    const handleLanguageChange = (language) => {
        setActiveLanguage(language);
    };

    const toggleArabicFields = () => {
        setShowArabicFields(prev => !prev);
    };

    const handleImagePreview = (file, setPreview) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreview(reader.result);
        };
        reader.readAsDataURL(file);
      };

    const loadContent = (lang) => {
        setContent({
            org: t('Home.org', { lng: lang }),
            org_ar: t('Home.org', { lng: 'ar' }),
            definition: {
                pt1: t('Home.definition.pt1', { lng: lang }),
                pt2: t('Home.definition.pt2', { lng: lang }),
                pt1_ar: t('Home.definition.pt1', { lng: 'ar' }),
                pt2_ar: t('Home.definition.pt2', { lng: 'ar' })
            },
            about: t('Home.about', { lng: lang }),
            about_ar: t('Home.about', { lng: 'ar' }),
            explore: t('Home.explore', { lng: lang }),
            explore_ar: t('Home.explore', { lng: 'ar' }),
            terms: t('Home.terms', { lng: lang }),
            terms_ar: t('Home.terms', { lng: 'ar' }),
            privacy: t('Home.privacy', { lng: lang }),
            privacy_ar: t('Home.privacy', { lng: 'ar' }),
            contact: {
                email: t('Home.contact.email', { lng: lang }),
                phone: t('Home.contact.phone', { lng: lang }),
                email_ar: t('Home.contact.email', { lng: 'ar' }),
                phone_ar: t('Home.contact.phone', { lng: 'ar' })
            },
            copyright: t('Home.copyright', { lng: lang }),
            copyright_ar: t('Home.copyright', { lng: 'ar' })
        });
    };

    const handleChange = (field, value) => {
        // setIsDirty(true);
        if (field.includes('.')) {
            const [parent, child] = field.split('.');
            setContent(prev => ({
                ...prev,
                [parent]: {
                    ...prev[parent],
                    [child]: value
                }
            }));
        } else {
            setContent(prev => ({
                ...prev,
                [field]: value
            }));
        }
    };

    const handleSubmit = async (lgo) => {
    try {
        setIsLoading(true);
        const formData = new FormData();
        formData.append("data", JSON.stringify(content));
        formData.append("file", logoPreview);
        const toastId = toast.loading('Updating content...');
        const response = await axios.post(`${url}/api/admin/home-content/${activeLanguage}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (response.status === 200) {
            toast.dismiss(toastId);
            toast.success('Content updated successfully');
            // setIsDirty(false);
            await i18n.reloadResources();
        } else {
            toast.dismiss(toastId);
            toast.error('Failed to update content');
        }
        } catch (error) {
            // Show backend error message if available, otherwise show generic message
            const errorMessage = error.response?.data?.message || 'Error updating content';
            toast.error(errorMessage);
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    // const handlePreview = () => {
    //     // Implement preview functionality
    //     window.open('/', '_blank');
    // };

    return (
        <div className="admin-editor-container">
            <div className="admin-editor-header">
                <div className="language-selector">
                    <button 
                        className={`language-button ${activeLanguage === 'en' ? 'active' : ''}`}
                        onClick={() => handleLanguageChange('en')}
                    >
                        English
                    </button>
                    <button 
                        className={`language-button ${activeLanguage === 'ar' ? 'active' : ''}`}
                        onClick={() => handleLanguageChange('ar')}
                    >
                        Arabic
                    </button>
                </div>
                {/* <div className="field-toggle">
                    <button 
                        className="toggle-button"
                        onClick={toggleArabicFields}
                    >
                        {showArabicFields ? 'Hide Arabic Fields' : 'Show Arabic Fields'}
                    </button>
                </div> */}
            </div>

            <div className="admin-editor-content">
                <div className="admin-form-section">
                    <h2 className="section-title">Organization Information</h2>
                    <div className='form-group space-y-4 flex'>
                    <label>Organization Logo</label>
                        <div className="flex items-center gap-4">
                            <Input
                            type="file"
                            accept="image/*"
                            onChange={(e) => {
                                if (e.target.files?.[0]) {
                                handleImagePreview(e.target.files[0], setLogoPreview);
                                handleChange("logo", e.target.files?.[0]);
                                }
                            }}
                            className="max-w-xl"
                            />
                            {logoPreview ? (
                            <div className="flex-shrink-0 w-[150px] h-[150px] rounded-lg border overflow-hidden">
                                <img
                                src={logoPreview}
                                alt="Logo preview"
                                className="object-contain"
                                style={{width: "150px", height: "150px", marginTop: "10px"}}
                                />
                            </div>
                            ) : (
                                <div className="flex-shrink-0 w-[150px] h-[150px] rounded-lg border overflow-hidden">
                                <img
                                src={content.logo}
                                alt="Logo preview"
                                className="object-contain"
                                style={{width: "150px", height: "150px", marginTop: "10px"}}
                                />
                            </div>
                            )}
                        </div>
                    </div>
                    {/* <div className="form-group">
                        <label>Platform Title</label>
                        <input
                            type="text"
                            value={content.title}
                            onChange={(e) => handleChange('title', e.target.value)}
                        />
                    </div> */}
                    <div className="form-group">
                        <label>Platform Title</label>
                        <input
                            type="text"
                            value={content.org}
                            onChange={(e) => handleChange('org', e.target.value)}
                        />
                    </div>
                    
                    {showArabicFields && (
                        <div className="form-group">
                            <label>Platform Title (Arabic)</label>
                            <input
                                type="text"
                                value={content.org_ar}
                                onChange={(e) => handleChange('org_ar', e.target.value)}
                            />
                        </div>
                    )}

                    <div className="form-group">
                        <label>Organization Name (Part 1)</label>
                        <input
                            type="text"
                            value={content.definition.pt1}
                            onChange={(e) => handleChange('definition.pt1', e.target.value)}
                        />
                    </div>
                    
                    {showArabicFields && (
                        <div className="form-group">
                            <label>Organization Name (Part 1) (Arabic)</label>
                            <input
                                type="text"
                                value={content.definition.pt1_ar}
                                onChange={(e) => handleChange('definition.pt1_ar', e.target.value)}
                            />
                        </div>
                    )}

                    <div className="form-group">
                        <label>Organization Name (Part 2)</label>
                        <input
                            type="text"
                            value={content.definition.pt2}
                            onChange={(e) => handleChange('definition.pt2', e.target.value)}
                        />
                    </div>
                    
                    {showArabicFields && (
                        <div className="form-group">
                            <label>Organization Name (Part 2) (Arabic)</label>
                            <input
                                type="text"
                                value={content.definition.pt2_ar}
                                onChange={(e) => handleChange('definition.pt2_ar', e.target.value)}
                            />
                        </div>
                    )}
                </div>

                <div className="admin-form-section">
                    <h2 className="section-title">Main Content</h2>
                    <div className="form-group">
                        <label>About Text</label>
                        <textarea
                            value={content.about}
                            onChange={(e) => handleChange('about', e.target.value)}
                        />
                    </div>
                    
                    {showArabicFields && (
                        <div className="form-group">
                            <label>About Text (Arabic)</label>
                            <textarea
                                value={content.about_ar}
                                onChange={(e) => handleChange('about_ar', e.target.value)}
                            />
                        </div>
                    )}

                    <div className="form-group">
                        <label>Explore Button Text</label>
                        <input
                            type="text"
                            value={content.explore}
                            onChange={(e) => handleChange('explore', e.target.value)}
                        />
                    </div>
                    
                    {showArabicFields && (
                        <div className="form-group">
                            <label>Explore Button Text (Arabic)</label>
                            <input
                                type="text"
                                value={content.explore_ar}
                                onChange={(e) => handleChange('explore_ar', e.target.value)}
                            />
                        </div>
                    )}
                </div>

                <div className="admin-form-section">
                    <h2 className="section-title">Footer Content</h2>
                    <div className="form-group">
                        <label>Terms of Use</label>
                        <textarea
                            value={content.terms}
                            onChange={(e) => handleChange('terms', e.target.value)}
                        />
                    </div>
                    
                    {showArabicFields && (
                        <div className="form-group">
                            <label>Terms of Use (Arabic)</label>
                            <textarea
                                value={content.terms_ar}
                                onChange={(e) => handleChange('terms_ar', e.target.value)}
                            />
                        </div>
                    )}

                    <div className="form-group">
                        <label>Privacy Policy</label>
                        <textarea
                            value={content.privacy}
                            onChange={(e) => handleChange('privacy', e.target.value)}
                        />
                    </div>
                    
                    {showArabicFields && (
                        <div className="form-group">
                            <label>Privacy Policy (Arabic)</label>
                            <textarea
                                value={content.privacy_ar}
                                onChange={(e) => handleChange('privacy_ar', e.target.value)}
                            />
                        </div>
                    )}
                </div>

                <div className="admin-form-section">
                    <h2 className="section-title">Contact Information</h2>
                    <div className="form-group">
                        <label>Email Address</label>
                        <input
                            type="email"
                            value={content?.contact?.email}
                            onChange={(e) => handleChange('contact.email', e.target.value)}
                        />
                    </div>
                    
                    {showArabicFields && (
                        <div className="form-group">
                            <label>Email Address (Arabic)</label>
                            <input
                                type="email"
                                value={content?.contact?.email_ar}
                                onChange={(e) => handleChange('contact.email_ar', e.target.value)}
                            />
                        </div>
                    )}

                    <div className="form-group">
                        <label>Phone Number</label>
                        <input
                            type="text"
                            value={content.contact.phone}
                            onChange={(e) => handleChange('contact.phone', e.target.value)}
                        />
                    </div>
                    
                    {showArabicFields && (
                        <div className="form-group">
                            <label>Phone Number (Arabic)</label>
                            <input
                                type="text"
                                value={content.contact.phone_ar}
                                onChange={(e) => handleChange('contact.phone_ar', e.target.value)}
                            />
                        </div>
                    )}
                </div>

                <div className="admin-form-section">
                    <h2 className="section-title">Copyright Information</h2>
                    <div className="form-group">
                        <label>Copyright Text</label>
                        <input
                            type="text"
                            value={content.copyright}
                            onChange={(e) => handleChange('copyright', e.target.value)}
                        />
                    </div>
                    
                    {showArabicFields && (
                        <div className="form-group">
                            <label>Copyright Text (Arabic)</label>
                            <input
                                type="text"
                                value={content.copyright_ar}
                                onChange={(e) => handleChange('copyright_ar', e.target.value)}
                            />
                        </div>
                    )}
                </div>

                <div className="admin-actions">
                    {/* <button
                        disabled={isLoading}
                        className="admin-button preview-button"
                        onClick={handlePreview}
                    >
                        Preview Changes
                    </button> */}
                    <button
                        className="admin-button save-button"
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        Save Changes
                    </button>
                </div>
            </div>
        </div>
    );
};

export default HomeContentEditor;